import React from 'react';
import { Button } from '@avila-tek/ui/src';
import { v4 as uuid } from 'uuid';
import { Option } from '../../../models';
import OptionFormDetail from './OptionFormDetail';

interface OptionFormProps {
  updateOptions?: React.Dispatch<React.SetStateAction<Option[]>>;
}

const OptionForm = ({ updateOptions = () => {} }: OptionFormProps) => {
  const [options, setOptions] = React.useState<Option[]>([
    { name: '', values: [], _id: uuid() },
  ]);
  React.useEffect(
    function updateOptionsHook() {
      updateOptions(options);
    },
    [options, updateOptions]
  );
  const addOption = (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
    e.preventDefault();
    if (options.length < 3) {
      setOptions((_options) => [
        ..._options,
        { name: '', values: [], _id: uuid() },
      ]);
    }
  };
  const remove = (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
    e.preventDefault();
    const { id } = e.currentTarget.dataset;
    setOptions((_options) => _options.filter((option) => option._id !== id));
  };
  const changeOptions = React.useCallback(setOptions, [setOptions]);
  return (
    <div className="w-full flex flex-col flex-wrap ">
      {options.map((option, i) => (
        <OptionFormDetail
          key={option._id}
          options={options}
          idx={i}
          setOptions={changeOptions}
          id={option._id}
          remove={remove}
        />
      ))}
      <div className="w-full flex flex-wrap flex-row justify-end ">
        <div className="">
          {options.length < 3 && (
            <Button
              type="button"
              className="py-1 px-6 w-fit "
              onClick={addOption}
            >
              Agregar Variante
            </Button>
          )}
        </div>
      </div>
    </div>
  );
};

export default OptionForm;
